export const BEESS_POINT = { text: "BEESS Point Person", value: "PointPerson" };
export const TEAM_LEAD = { text: "Team Lead", value: "TeamLead" };
export const TEAM_MEMBER = { text: "Team Member", value: "Member" };
export const CONSULTANT = {text: "Consultant", value: "Consultant" };
export const ALL = [ TEAM_MEMBER, BEESS_POINT, TEAM_LEAD, CONSULTANT ];
